









































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem, Row } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop() id: number | undefined;
  @Prop() disabled : Boolean;
  model: proxy.ChannelTypeDto = new proxy.ChannelTypeDto();
  allchannels = [];
  channels = [];
  // channelids = [];
  channelTypeChannels = [];
  merchants = [];
  // disabled = false;
  groupflags = [];
  flag = '';
  columns4 = [
    {
      title: "序号",
      width: 80,
      slot: "xuhao",
    },
    {
      title: "名称",
      key: "name",
    },
    {
      title: "权重",
      slot: "weight",
    },
    {
      title: "状态",
      slot: "status",
    },
  ];
  get prox() {
    return new proxy.ChannelTypeServiceProxy();
  }
  syncrate() {
    if (!this.flag) {
      this.merchants.map(x => {
        x.rate = this.model.rate;
      })
    } else {
      debugger;
      this.merchants.map(x => {
        if (x.groupFlag == this.flag) {
          this.$set(x, 'rate', this.model.rate)
        }
      })
    }
    this.merchants = this.merchants.filter(x => 1 == 1);
  }
  quanxuan() {
    this.merchants.map(x => {
      x.check = true;
    })
    this.$forceUpdate();
  }
  clearxuanzhong() {
    this.merchants.map(x => {
      x.check = false;
    })
    this.$forceUpdate();
  }
  jinyongchange(e) {
    if (e) {
      this.channels = this.allchannels.filter((x) => x.status == 0);
    } else {
      this.channels = this.allchannels;
    }
  }
  rowchange(row, index) {
    this.channelTypeChannels[index] = row;
  }
  channelidschange(ids) {
    // this.disabled = true
    let arr = this.channels.filter((x) => ids.includes(x.id));
    let arr2 = [];
    arr.map((x) => {
      let m = {
        name: x.name,
        status: x.status,
        weight: 1,
        id: 0,
        channelId: x.id,
      };
      if (
        this.model.channelTypeChannels &&
        this.model.channelTypeChannels.length
      ) {
        let index = this.model.channelTypeChannels.findIndex(
          (p) => p.channelId == x.id
        );
        if (index != -1) {
          m.id = this.model.channelTypeChannels[index].id;
          if (this.model.channelTypeChannels[index].weight > 0) {
            m.weight = this.model.channelTypeChannels[index].weight;
          }
        }
      }
      arr2.push(m);
    });
    this.channelTypeChannels = arr2;
    this.disabled = false
  }
  save() {
    //this.model.channelTypeChannels = [];
    // this.channelTypeChannels.map((x) => {
    //   let m = new proxy.ChannelTypeChannelDto();
    //   m.id = x.id;
    //   m.channelId = x.channelId;
    //   m.weight = x.weight;
    //   this.model.channelTypeChannels.push(m);
    // });
    // let arr = this.merchants.filter(x => x.check).map(x => {
    //   let m = this.model.merchantChannelTypes.find(p => p.merchantId == x.id);
    //   m = m || new proxy.MerchantChannelTypeDto();
    //   m.merchantId = x.id;
    //   m.rate = x.rate;
    //   return m;
    // });
    // let arr2 = this.merchants.map(x => {
    //   let m = this.model.merchantAgentRates.find(p => p.merchantId == x.id);
    //   m = m || new proxy.MerchantAgentRateDto();
    //   m.merchantId = x.id;
    //   m.agentRate = x.agentRate;
    //   return m;
    // })
    // this.model.merchantChannelTypes = arr;
    // this.model.merchantAgentRates = arr2;
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.prox.createOrUpdate(this.model).then(() => {
          (this.$refs.roleForm as any).resetFields();
          this.$Notice.success({ title: "保存成功" });
          this.$emit("save-success");
          this.$emit("input", false);
        });
      }
    });
  }
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  created() {
    
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.disabled = true
      this.prox.queryModel(this.id).then((x) => {
          this.model = x;
          this.disabled = false
        });
      /*
      this.flag = '';
      this.groupflags = [];
      // this.disabled = true
      // this.channelids = [];
      this.channelTypeChannels = [];
      let req = new proxy.ChannelSimpleInputDto();
    new proxy.ChannelServiceProxy().queryAllList(req).then((x) => {
      this.allchannels = x;
      this.channels = this.allchannels;


      let req2 = new proxy.MerchantSimpleInputDto();
      new proxy.MerchantServiceProxy().queryAllList(req2).then((x) => {
        this.$set(this, 'merchants', x);
        // this.merchants = x;
        this.merchants.map((x) => {
          x.check = false;
          if (x.groupFlag != null && (this.groupflags.length == 0 || this.groupflags.findIndex(g => g == x.groupFlag) == -1)) {
            this.groupflags.push(x.groupFlag);
          }
        });
        this.prox.queryModel(this.id).then((x) => {
          this.model = x;
          this.model.merchantChannelTypes = this.model.merchantChannelTypes || [];
          this.model.merchantAgentRates = this.model.merchantAgentRates || [];
          this.merchants.map((c) => {
            let i = this.model.merchantChannelTypes.findIndex(
              (p) => p.merchantId == c.id
            );
            if (i != -1) {
              c.check = true;
              c.rate =
                this.model.merchantChannelTypes[i].rate; // 这里如果给商户费率设置的是0的话会自动变成产品的费率   明天看下改一下
            } else {
              c.rate = this.model.rate;
            }
          });
          this.merchants.map((c) => {
            let i = this.model.merchantAgentRates.findIndex(
              (p) => p.merchantId == c.id
            );
            if (i != -1) {
              c.agentRate = this.model.merchantAgentRates[i].agentRate || 0;
            } else {
              c.agentRate = 0;
            }
          });

          if (
            this.model.channelTypeChannels &&
            this.model.channelTypeChannels.length
          ) {
            // this.channelids = this.model.channelTypeChannels.map((x) => {
            //   return x.channelId;
            // });
            let arr = [];
            this.model.channelTypeChannels.map((x) => {
              let c = this.channels.find((p) => p.id == x.channelId);
              let m = {
                name: c.name,
                id: x.id,
                weight: x.weight,
                status: c.status,
                channelId: c.id,
              };
              arr.push(m);
            });
            this.channelTypeChannels = arr;
            this.disabled = false
          } else {
            this.disabled = false
          }
        });

      });
    });
     */
    }
  }

  roleRule = {
    suppName: [
      {
        required: true,
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
  };
}
